import { graphql } from 'react-relay';
import {
  type GraphQLReturn,
  useMutationAsync,
} from '@cherre-frontend/data-fetching';
import type {
  CustomPropertyAttribute,
  CustomPropertyAttributeJson,
} from '../../../types/CustomPropertyAttribute';
import type { useUpsertCustomPropertyAttributesMutation } from './__generated__/useUpsertCustomPropertyAttributesMutation.graphql';

export const useUpsertCustomPropertyAttributes = () => {
  return useMutationAsync(
    graphql`
      mutation useUpsertCustomPropertyAttributesMutation(
        $objects: [sys_property_type_custom_attributes_insert_input!]!
      ) {
        insert_sys_property_type_custom_attributes(
          objects: $objects
          on_conflict: {
            constraint: property_type_custom_attribut_property_type_id_organization_key
            update_columns: [custom_attributes]
          }
        ) {
          affected_rows
        }
      }
    ` as GraphQLReturn<useUpsertCustomPropertyAttributesMutation>,
    {
      mapVariables: (attributes: CustomPropertyAttribute[]) => {
        const attributesByPropertyType = attributes.reduce(
          (acc: Record<number, CustomPropertyAttributeJson[]>, attribute) => {
            const { propertyTypeId } = attribute;
            acc[propertyTypeId] = acc[propertyTypeId] || [];
            acc[propertyTypeId].push({
              label: attribute.label,
              slug: attribute.slug,
              order: attribute.order,
              type: attribute.type,
              active: attribute.active,
              required: attribute.required,
            });
            return acc;
          },
          {}
        );

        const objects = Object.entries(attributesByPropertyType).map(
          ([property_type_id, custom_attributes]) => ({
            property_type_id: Number(property_type_id),
            custom_attributes,
          })
        );
        return { objects };
      },
    }
  );
};
